import React from "react";

class Footer extends React.Component {
  render() {
    return (
      <footer>
        <span>
          &copy; 2018 - {new Date().getFullYear()} - Société AtisSystem - N° SIRET 45062901900040 - 35 rue de l'industrie - 69530 BRIGNAIS
        </span>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Navigation/Footer/Footer.js